const it = {
    actionAlready: "Non sei ancora registrato? Accedi",
    actionExit: "Logout",
    actionLogin: "ACCEDI",
    actionRegister: "REGISTRATI",
    actionSave: "SALVA",
    actionStart: "INIZIA",
    actionContinue: "CONTINUA",
    actionReset: "REIMPOSTA VALUTAZIONE",
    actionDoDiagnost: "MOSTRA DIAGNOSTICA",
    actionYes: "Sì",
    actionNo: "No",
    actionNext: "AVANTI",
    actionBusinessCase: "MOSTRA BUONA PRATICA DELL'AZIENDA",
    actionBusinessCases: "MOSTRA BUONE PRATICHE DELLE AZIENDE",
    actionOpenUrl: "APRI URL",
    actionFilter: "FILTRA",

    /** HOME */
    msgHomeTitleOne: "Misura e aumenta il livello di maturità circolare della tua azienda di arredamento",
    msgHomeSubTitle: "Lo strumento online FurnCIRCLE valuta i progressi della tua azienda verso la maturità circolare in base alle strategie di design circolare implementate",

    msgHomeSection2: "Valuta e migliora la maturità dell’economia circolare della tua azienda del mobile",
    msgHomeSection2Text: "<span style='font-weight:bold;'>Strumento di valutazione dell’economia circolare FurnCIRCLE</span><br/><br/>FurnCIRCLE è uno strumento online di autovalutazione che aiuta i produttori di mobili a valutare la propria maturità nell’economia circolare e a identificare opportunità di miglioramento.<br/><br/><span style='font-weight:bold;'>Sei pronto a valutare la tua maturità circolare?</span><ul style='padding-left: 20px'><li>Rispondi alle domande sulle strategie di design circolare implementate nella tua azienda.</li><li>Scopri il tuo livello di maturità nell’economia circolare.</li><li>Individua strategie e buone pratiche per aiutare la tua azienda a passare al livello successivo.</li><li>Impara da esempi reali del settore e continua a migliorare la tua performance circolare.</li></ul>",
    msgHomeSection21Text: "<span style='font-weight:bold;'>Contribuisci alla valutazione europea della circolarità del settore del mobile | Progetto R-evolve</span><br/><br/>FurnCIRCLE è attualmente utilizzato nel <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>progetto R-evolve</a> per valutare la maturità dell’economia circolare del settore europeo del mobile. <span style='font-weight:bold;'>Più di 400 aziende in tutta Europa</span> sono invitate a partecipare e ad aiutare a mappare l’attuale livello di circolarità del settore.<br/><br/>Partecipa alla valutazione, valuta la tua azienda e contribuisci a plasmare il futuro del settore.<br/><br/>Tutti i dati sono trattati in modo confidenziale e utilizzati solo in forma aggregata per finalità di benchmarking e ricerca. <span style='font-weight:bold;'>I partecipanti riceveranno accesso a risultati di benchmarking aggregati</span>, che consentiranno loro di confrontare le proprie performance con le medie di settore sulla base di dati anonimizzati e aggregati delle aziende partecipanti del settore europeo del mobile.<br/><br/>La valutazione richiede circa 30-45 minuti.",
    msgHomeSection3: "Partner",
    msgHomeSection2Btn: "Inizia la tua valutazione",
    msgHomeSection3Btn: "CONTATTO",

    /** HEADER */
    msgHeader1: "Strategie di design circolare e buone pratiche",
    msgHeader4: "Accedi",

    /** DRAWER */
    msgCompany: "AZIENDA",
    msgDrawer1: "1. Rispondi",
    msgDrawer2: "2. Valuta",
    msgDrawer3: "3. Migliora",
    msgDrawer4: "Raccolta di strategie",
    msgDrawer6: "Impostazioni",
    msgDrawer7: "Logout",

    /** LOGIN */
    msgWelcome: "Benvenuto",
    msgWelcomeSubtitle: "Accedi per continuare",

    /** REGISTER */
    msgGetStarted: "Inizia",
    msgGetStartedSubtitle: "Questo strumento di autovalutazione è gratuito e confidenziale",

    msgFirstname: "Nome",
    msgLastname: "Cognome",
    msgEmail: "Email",
    msgPassword: "Password",
    msgConfirmPassword: "Conferma password",
    msgCompanyUser: "Azienda o nome utente",

    msgLegalRegister: "Ho letto e accetto la <a href='https://ambitcluster.org/en/privacy-policy'>Informativa sulla Privacy.</a>",
    errorLegalRegister: "Devi leggere e accettare l'Informativa sulla Privacy prima di continuare",
    msgLegalRegisterText: "Nota: I dati personali vengono raccolti da AMBIT tramite lo Strumento FurnCIRCLE esclusivamente per scopi tecnici e operativi. Le risposte al sondaggio saranno analizzate nell'ambito del progetto R-evolve. Nessun dato personale o informazione che identifichi l'azienda sarà condivisa con i partner del consorzio R-evolve. Tutte le risposte saranno analizzate su base strettamente anonima. A fini statistici, i dati possono essere aggregati per paese o settore di attività. In nessun caso i risultati generati dallo strumento saranno collegati o utilizzati per identificare una singola azienda.",

    msgNotRegister: "Non sei ancora registrato? <b>Crea un account qui</b>",
    msgAlreadyRegister: "Sei già registrato? <b>Accedi qui</b>",

    /** HOME TOOL */
    msgClickImage: "Clicca per espandere il sistema del modello lineare versus circolare.",

    msgArea: "AREA",
    msgProgress: "DOMANDE RISPOSTE",

    msgAssessmentAreas: "Strategie di design circolare e ciclo di vita del prodotto",
    msgAssessmentDesc: "Le strategie di progettazione circolare vengono applicate principalmente durante la fase di progettazione e sviluppo dei prodotti. Tuttavia, il loro impatto (positivo) si manifesta in una o più fasi successive del ciclo di vita del prodotto, supportato dai servizi post-vendita. Pertanto, un modo per classificare le strategie di progettazione circolare è in base alla fase del ciclo di vita su cui incidono: progettazione, risorse materiali, produzione, distribuzione, fase d'uso e fine vita.<br/><br/>Per sviluppare le strategie di circolarità, è fondamentale l'approccio generale di un'azienda verso la futura Economia Circolare, insieme agli 'aspetti del prodotto' definiti all'Art. 5(1) del Regolamento europeo sull'Ecodesign per i Prodotti Sostenibili (ESPR) e al Passaporto Digitale di Prodotto (DPP) introdotto dall'ESPR.<br/><br/>L'ESPR è uno dei pilastri della strategia UE per una Economia Circolare (CE) efficiente nell'uso delle risorse, a bassa tossicità e favorevole al clima. Definisce un quadro di condizioni vincolanti di accesso al mercato per i prodotti, richiedendo il rispetto di obiettivi ambiziosi in materia ambientale ed efficienza delle risorse per rimanere entro i limiti planetari. In base agli 'aspetti del prodotto' di cui all'Art. 5(1), i prodotti devono essere progettati per un uso prolungato, facile riparazione, riuso e ricondizionamento, nonché per un riciclo sicuro (le cosiddette strategie R). Devono inoltre essere privi di sostanze problematiche e idonei a un recupero di materiali di alta qualità.<br/><br/>Il DPP, come introdotto dall'ESPR, è pensato per fornire la corrispondente infrastruttura armonizzata dei dati di prodotto, in grado di favorire trasparenza, tracciabilità e innovazione sostenibile delle imprese.<br/><br/>Per maggiori dettagli, consultare la scheda R-evolve | <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>https://r-evolve.eu/</a><br/><br/><span style='font-weight:bold;'>Per favore, rispondi a tutte le domande per ciascun blocco o fase del ciclo di vita, determina il tuo livello di maturità circolare e pianifica il miglioramento e la transizione verso un'Economia Circolare più avanzata.</span>",

    msgAssessment: "Valutazione FurnCIRCLE",
    msgNotApply: "Seleziona tutte le risposte che si applicano alle attuali performance circolari della tua azienda. Le risposte vengono salvate automaticamente.",
    msgMarkImportant: "Segna come importante",
    msgComment: "Commento",
    msgCommentHolder: "Puoi scrivere qui qualsiasi informazione correlata o i tuoi commenti.",

    /** ANSWER */
    msgPerformance: "Rapporto di valutazione",
    msgPerformanceSubtitle: "Scopri l'indice di maturità circolare della tua azienda e di ogni fase del ciclo di vita dei tuoi prodotti.",
    msgCompanyLevel: "Indice di maturità circolare della tua azienda (0%-100%)",
    msgBlockArea: "FASE DEL CICLO DI VITA",
    msgBlockValues: "VALORI",

    /** ASSESS */
    msgImprovement: "Rapporto di miglioramento",
    msgImprovementMainSubtitle: "Scopri cosa puoi fare per migliorare continuamente la circolarità della tua azienda. Conosci le strategie di design e le buone pratiche aziendali per portare la tua azienda al livello successivo.</br></br>Le fasi del ciclo di vita e le strategie di design circolare con un’etichetta/cerchio “rosso” hanno un livello di prestazione uguale o inferiore al 25% del loro valore massimo e possono quindi essere considerate una priorità assoluta per il miglioramento della circolarità aziendale. Le fasi o le strategie con un’etichetta/cerchio “arancione” hanno un livello di prestazione superiore al 25% e inferiore o uguale al 75% e quindi è anche importante affrontarne il miglioramento. Le fasi o le strategie con un’etichetta/cerchio “verde” hanno un livello di prestazione superiore al 75% e sono quindi meno prioritarie per il miglioramento.",
    msgImprovementSubtitle: "Scopri cosa puoi fare per migliorare continuamente la circolarità della tua azienda. Conosci le strategie di design e le buone pratiche aziendali per portare la tua azienda al livello successivo.",
    msgLifecyclePhases: "Fasi del ciclo di vita",
    msgLifecycleIndex: "Indice di circolarità della fase",
    msgActionsToImplement: "Azioni da implementare:",
    msgBaselineScore: "Il mio punteggio di base",
    msgBusinessCaseEmpty: "Congratulazioni! Hai già implementato le principali strategie incluse in questa categoria",

    msgCat1: "ECONOMICA E ORGANIZZATIVA",
    msgCat2: "SOCIETARIA",
    msgCat3: "AMBIENTALE",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Sfoglia ed esplora la collezione completa di strategie di design circolare e buone pratiche aziendali del progetto FurnCIRCLE.",
    msgLifecyclePhase: "Fase del ciclo di vita",
    msgDifficulty: "Difficoltà di implementazione",
    msgBusinessDynamics: "Generazione o erogazione di valore",
    msgBusinessFactors: "Proposta di valore / Costi / Benefici",

    /** SETTINGS */
    msgUserInfo: "Informazioni utente",
    msgUserCredentials: "Credenziali utente",

    /** MODAL */
    msgAreSure: "Sei sicuro?",

    msgSuccess: "Dati aggiornati con successo",
    msgDeleteSuccess: "Dati eliminati con successo",

    /** ALT TEXT */
    msgSaveCommentAlt: "Salva il “Commento”. Non è necessario salvare le risposte alle domande; vengono salvate automaticamente.",
    msgDifficultyAlt: "Questa etichetta indica la difficoltà nell'implementare la strategia di design circolare.",
    msgBusinessBlockAlt: "Questa etichetta indica quale blocco aziendale del modello CANVAS (Generazione di Valore o Consegna del Valore) è influenzato dall'implementazione della strategia di design circolare.",
    msgImpactBlockAlt: "Questa etichetta indica quale blocco di impatto del modello CANVAS (Costi, Benefici o Proposta di Valore) è influenzato dall'implementazione della strategia di design circolare.",

    /** ERROR */
    errorOblData: "Compila tutti i campi obbligatori",
    errorEmailFormat: "Errore nel formato dell'email",
    errorUserIncorrect: "Email/password errati",
    errorSend: "Errore di comunicazione, attendere e riprovare più tardi",
    errorLength: "È stato superato il numero di caratteri consentito",
    errorPassSame: "Le password non coincidono",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Recupero password",
    msgRecoveryPasswordSubtitle: "Inserisci il tuo indirizzo email per ricevere un codice di reimpostazione della password.",
    msgCode: "Codice",
    msgNewPassword: "Nuova password",
    actionRequestCode: "RICHIEDI CODICE",
    actionUpdate: "AGGIORNA",
    actionBack: "INDIETRO",
    msgForgetPassword: "Hai dimenticato la password?",
    errorRecovery: "Errore nel recupero della password, controlla il codice fornito",

    /** FOOTER */
    msgFooterContact: "CONTATTO",

    msgFooterGr: "Finanziato dall'Unione Europea. Le opinioni espresse sono esclusivamente quelle degli autori e non riflettono necessariamente quelle dell'Unione Europea. Né l'Unione Europea né l'autorità concedente possono esserne ritenute responsabili. Riferimento del bando e dell'accordo di sovvenzione: SOCPL-2022-SOC-DIALOG-01 (Progetto 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Tutti i diritti riservati",

    msgFooterLegal: "Note legali",
    msgFooterPrivacy: "Privacy",
    msgFooterCookies: "Politica sui cookie",

    /** PROGRESS VALUES */
    msgProgress0: "Strategie di design circolare",

    /** COMPANY SIZES */
    msgCompanySize: "Dimensione dell'azienda",
    msgCompanySize1: "Meno di 10 dipendenti",
    msgCompanySize2: "10-30 dipendenti",
    msgCompanySize3: "30-50 dipendenti",
    msgCompanySize4: "Più di 50 dipendenti",

    /** PRODUCT TYPES */
    msgProductType: "Tipologia di prodotti che produci",
    msgProductType1: "Mobili per camera da letto e letti",
    msgProductType2: "Camere per bambini/ragazzi",
    msgProductType3: "Sistemi letto: materassi e basi",
    msgProductType4: "Mobili per zona living",
    msgProductType5: "Sedie",
    msgProductType6: "Cucine",
    msgProductType7: "Mobili imbottiti",
    msgProductType8: "Mobili da esterno",
    msgProductType9: "Mobili in kit / DIY",
    msgProductType10: "Arredi per strutture sanitarie e assistenziali (ospedali, case di cura, ecc.)",
    msgProductType11: "Arredi per spazi pubblici (aeroporti, chiese, teatri e cinema) esclusa la seduta",
    msgProductType12: "Mobili residenziali su misura",
    msgProductType13: "Accessori - Elementi complementari",
    msgProductType14: "Accessori - Oggetti decorativi",
    msgProductType15: "Accessori - Tessili",
    msgProductType16: "Arredi commerciali (retail / contract interiors)",
    msgProductType17: "Componenti semilavorati per mobili",
    msgProductType18: "Altri mobili",
    msgProductType19: "Mobili da bagno (inclusi piani di lavoro)",
    msgProductType20: "Mobili per ufficio",
    msgProductType21: "Pareti divisorie / partizioni per ufficio",
    msgProductType22: "Sedute per ufficio",
    msgProductType23: "Sedute pubbliche / sedute per spazi collettivi",
    msgProductType24: "Pannelli acustici / arredi acustici",
    msgProductType25: "Componenti per mobili da ufficio",
    msgProductType26: "Altri mobili/attrezzature per ufficio",
    msgProductType27: "Arredi scolastici",

    /* COUNTRIES */
    msgCountry: "Paese",
    msgAfghanistan: "Afghanistan",
    msgAlbania: "Albania",
    msgAlgeria: "Algeria",
    msgAmericanSamoa: "Samoa Americane",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antartide",
    msgAntiguaandBarbuda: "Antigua e Barbuda",
    msgArgentina: "Argentina",
    msgArmenia: "Armenia",
    msgAruba: "Aruba",
    msgAustralia: "Australia",
    msgAustria: "Austria",
    msgAzerbaijan: "Azerbaigian",
    msgBahamas: "Bahamas",
    msgBahrain: "Bahrein",
    msgBangladesh: "Bangladesh",
    msgBarbados: "Barbados",
    msgBelarus: "Bielorussia",
    msgBelgium: "Belgio",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhutan",
    msgBolivia: "Bolivia",
    msgBosniaHerzegovina: "Bosnia ed Erzegovina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Isola Bouvet",
    msgBrazil: "Brasile",
    msgBritishIndian: "Territorio britannico dell'Oceano Indiano",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgaria",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Cambogia",
    msgCameroon: "Camerun",
    msgCanada: "Canada",
    msgCapeVerde: "Capo Verde",
    msgCaymanIslands: "Isole Cayman",
    msgCentralAfrican: "Repubblica Centrafricana",
    msgChad: "Ciad",
    msgChile: "Cile",
    msgChina: "Cina",
    msgChristmasIsland: "Isola di Natale",
    msgCocosIslands: "Isole Cocos (Keeling)",
    msgColombia: "Colombia",
    msgComoros: "Comore",
    msgCongo: "Congo",
    msgRepublicCongo: "Repubblica Democratica del Congo",
    msgCookIslands: "Isole Cook",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Costa d'Avorio",
    msgCroatia: "Croazia",
    msgCuba: "Cuba",
    msgCyprus: "Cipro",
    msgCzechRepublic: "Repubblica Ceca",
    msgDenmark: "Danimarca",
    msgDjibouti: "Gibuti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "Repubblica Dominicana",
    msgEastTimor: "Timor Est",
    msgEcuador: "Ecuador",
    msgEgypt: "Egitto",
    msgEngland: "Inghilterra",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Guinea Equatoriale",
    msgEritrea: "Eritrea",
    msgEstonia: "Estonia",
    msgEthiopia: "Etiopia",
    msgFalklandIslands: "Isole Falkland",
    msgFaroeIslands: "Isole Fær Øer",
    msgFijiIslands: "Isole Figi",
    msgFinland: "Finlandia",
    msgFrance: "Francia",
    msgFrenchGuiana: "Guyana Francese",
    msgFrenchPolynesia: "Polinesia Francese",
    msgFrenchSouthern: "Territori Francesi del Sud",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Georgia",
    msgGermany: "Germania",
    msgGhana: "Ghana",
    msgGibraltar: "Gibilterra",
    msgGreece: "Grecia",
    msgGreenland: "Groenlandia",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Guadalupa",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guinea",
    msgGuineaBissau: "Guinea-Bissau",
    msgGuyana: "Guyana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Isole Heard e McDonald",
    msgHolySee: "Santa Sede (Stato della Città del Vaticano)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Ungheria",
    msgIceland: "Islanda",
    msgIndia: "India",
    msgIndonesia: "Indonesia",
    msgIran: "Iran",
    msgIraq: "Iraq",
    msgIreland: "Irlanda",
    msgIsrael: "Israele",
    msgIsleMan: "Isola di Man",
    msgItaly: "Italia",
    msgJamaica: "Giamaica",
    msgJapan: "Giappone",
    msgJersey: "Jersey",
    msgJordan: "Giordania",
    msgKazakhstan: "Kazakistan",
    msgKenya: "Kenya",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuwait",
    msgKyrgyzstan: "Kirghizistan",
    msgLaos: "Laos",
    msgLatvia: "Lettonia",
    msgLebanon: "Libano",
    msgLesotho: "Lesotho",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Jamahiriya Araba Libica",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Lituania",
    msgLuxembourg: "Lussemburgo",
    msgMacao: "Macao",
    msgNorthMacedonia: "Macedonia del Nord",
    msgMadagascar: "Madagascar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malaysia",
    msgMaldives: "Maldive",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Isole Marshall",
    msgMartinique: "Martinica",
    msgMauritania: "Mauritania",
    msgMauritius: "Mauritius",
    msgMayotte: "Mayotte",
    msgMexico: "Messico",
    msgMicronesia: "Micronesia, Stati Federati di",
    msgMoldova: "Moldavia",
    msgMonaco: "Monaco",
    msgMongolia: "Mongolia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegro",
    msgMorocco: "Marocco",
    msgMozambique: "Mozambico",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Paesi Bassi",
    msgNetherlandsAntilles: "Antille Olandesi",
    msgNewCaledonia: "Nuova Caledonia",
    msgNewZealand: "Nuova Zelanda",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Isola Norfolk",
    msgNorthKorea: "Corea del Nord",
    msgNorthernIreland: "Irlanda del Nord",
    msgNorthernMariana: "Isole Marianne del Nord",
    msgNorway: "Norvegia",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palestina",
    msgPanama: "Panama",
    msgPapua: "Papua Nuova Guinea",
    msgParaguay: "Paraguay",
    msgPeru: "Perù",
    msgPhilippines: "Filippine",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polonia",
    msgPortugal: "Portogallo",
    msgPuertoRico: "Porto Rico",
    msgQatar: "Qatar",
    msgReunion: "Riunione",
    msgRomania: "Romania",
    msgRussianFederation: "Federazione Russa",
    msgRwanda: "Ruanda",
    msgSaintHelena: "Sant'Elena",
    msgSaintKitts: "Saint Kitts e Nevis",
    msgSaintLucia: "Santa Lucia",
    msgSaintPierre: "Saint Pierre e Miquelon",
    msgSaintVincent: "Saint Vincent e Grenadine",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Sao Tomé e Principe",
    msgSaudiArabia: "Arabia Saudita",
    msgScotland: "Scozia",
    msgSenegal: "Senegal",
    msgSerbia: "Serbia",
    msgSeychelles: "Seychelles",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapore",
    msgSlovakia: "Slovacchia",
    msgSlovenia: "Slovenia",
    msgSolomonIslands: "Isole Salomone",
    msgSomalia: "Somalia",
    msgSouthAfrica: "Sud Africa",
    msgSouthSandwich: "Isole Georgie del Sud e Sandwich del Sud",
    msgSouthKorea: "Corea del Sud",
    msgSouthSudan: "Sud Sudan",
    msgSpain: "Spagna",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Sudan",
    msgSuriname: "Suriname",
    msgSvalbardJan: "Svalbard e Jan Mayen",
    msgSwaziland: "Swaziland",
    msgSweden: "Svezia",
    msgSwitzerland: "Svizzera",
    msgSyria: "Siria",
    msgTajikistan: "Tagikistan",
    msgTanzania: "Tanzania",
    msgThailand: "Thailandia",
    msgTimorLeste: "Timor Est",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad e Tobago",
    msgTunisia: "Tunisia",
    msgTurkey: "Turchia",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Isole Turks e Caicos",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ucraina",
    msgUnitedArabEmirates: "Emirati Arabi Uniti",
    msgUnitedKingdom: "Regno Unito",
    msgUnitedStates: "Stati Uniti",
    msgUnitedStatesMinor: "Isole Minori Esterne degli Stati Uniti",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Uzbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Isole Vergini Britanniche",
    msgVirginIslandsUS: "Isole Vergini degli Stati Uniti",
    msgWales: "Galles",
    msgWallisFutuna: "Wallis e Futuna",
    msgWesternSahara: "Sahara Occidentale",
    msgYemen: "Yemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabwe",
}
export default it;